function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 1a1 1 0 10-2 0v10a1 1 0 102 0V1zm6 0a1 1 0 00-2 0v10a1 1 0 102 0V1z",
  fill: "#FED602"
});

var SvgIconUnion = function SvgIconUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDggMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAxQzIgMC40NDc3MTUgMS41NTIyOSAwIDEgMEMwLjQ0NzcxNiAwIDAgMC40NDc3MTUgMCAxVjExQzAgMTEuNTUyMyAwLjQ0NzcxNSAxMiAxIDEyQzEuNTUyMjggMTIgMiAxMS41NTIzIDIgMTFMMiAxWk04IDFDOCAwLjQ0NzcxNSA3LjU1MjI4IDAgNyAwQzYuNDQ3NzIgMCA2IDAuNDQ3NzE1IDYgMUw2IDExQzYgMTEuNTUyMyA2LjQ0NzcxIDEyIDcgMTJDNy41NTIyOCAxMiA4IDExLjU1MjMgOCAxMUw4IDFaIiBmaWxsPSIjRkVENjAyIi8+Cjwvc3ZnPgo=";
export { SvgIconUnion as ReactComponent };